module.exports = __webpack_public_path__ + "930c13f1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/global/Header/live.gif
// module id = 932
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 16